import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'lib-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConfirmDialogComponent {

  constructor( 
    private dialogRef: MatDialogRef<ConfirmDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: DataConfirmDialog) {}

  cancel() {
    this.dialogRef.close();
  }

  confirm() {
    this.dialogRef.close('confirm');
  }
}

export interface DataConfirmDialog {
  title: string;
  message: string;
  id: number;
  textCancel: string,
  textConfirm: string,
  checkID: string,
}